module.exports = __webpack_public_path__ + "img/V-63-ST-1500-BB.1e7e3224.png";